import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanTags',
  standalone: true,
})
export class CleanTagsPipe implements PipeTransform {
  constructor() {}

  cleanHeadingTags(str: string) {
    // Regular expression to match <h1> to <h6> tags but keep their content
    let headingTagRegex = /<\/?h[1-6][^>]*>/gi;

    // Replace heading tags with an empty string, keeping the content
    let cleanedString = str.replace(headingTagRegex, '');

    return cleanedString;
  }

  cleanParagraphTags(str: string): string {
    // Regular expression to match opening and closing <p> tags but keep their content
    let paragraphTagRegex = /<\/?p[^>]*>/gi;

    // Replace paragraph tags with an empty string, keeping the content
    let cleanedString = str.replace(paragraphTagRegex, '');

    return cleanedString;
  }

  transform(data: string | undefined): string {
    if (data) {
      let noHeadingData = this.cleanHeadingTags(data);
      let cleanData = this.cleanParagraphTags(noHeadingData);
      return cleanData;
    } else {
      return '';
    }
  }
}
